import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    errorMyInfoFailed: '',
};

const getMyInfoDataReducer = (state = initialState, action) => {
    switch (action.type.type) {
        case actionTypes.GET_MYINFO_DATA_SUCCESS:
            return updateObject(state, {
                errorMyInfoFailed: '',
            });
        case actionTypes.GET_MYINFO_DATA_FAILED:
            return updateObject(state, {
                errorMyInfoFailed: action.type.error.msg,
            });
        default: {
            return state;
        }
    }
};

export default getMyInfoDataReducer;
